import { FTable, FCell, TableProps, CellProps } from "@wptb/dev/types";
import store from "@wptb/external/store";
import { buildBlockRecursive } from "@wptb/external/front-utils";

export const stateToFTable = (id: string): FTable | null => {
  const storeState = store.getState();
  const allProps = storeState.props;
  const tableProps = allProps[id] as TableProps;
  if (!tableProps) {
    return null;
  }

  const innerBlocks = storeState.innerBlocks;

  const table = storeState.tables[id]?.desktop;
  if (!table) {
    return null;
  }

  const cells: FCell[][] = [];

  for (let i = 0; i < table.length; i++) {
    const row = table[i];
    const rowCells: FCell[] = [];
    for (let j = 0; j < row.length; j++) {
      const cell = row[j];
      const innerBlock = innerBlocks[cell];
      const cellProps = allProps[cell] as CellProps;
      let el = '';
      for (const blockId of innerBlock.blockOrder) {
        el += buildBlockRecursive(blockId, innerBlocks, allProps, [cellProps, tableProps]);
      }
      rowCells.push({
        ...allProps[cell],
        el,
      });
    }
    cells.push(rowCells);
  }

  return {
    props: tableProps,
    cells,
  };
};
